import type { OrganisationRole } from "./enums.js";

/** Apps a workspace can turn on. Manage is the shell and is always available. */
export const WORKSPACE_APPS = ["hub", "mail", "site", "team", "social", "engage"] as const;
export type WorkspaceApp = (typeof WORKSPACE_APPS)[number];

export function isWorkspaceApp(value: string): value is WorkspaceApp {
	return (WORKSPACE_APPS as readonly string[]).includes(value);
}

/**
 * Owners and admins may open every app the workspace has turned on.
 * Other roles need an explicit grant. Hiding a menu is not this check.
 */
export function canOpenWorkspaceApp(input: {
	role: OrganisationRole;
	enabled: boolean;
	granted: boolean;
	app?: WorkspaceApp;
}): boolean {
	if (!input.enabled) return false;
	if (input.role === "owner" || input.role === "admin") return true;
	if (input.role === "user") return input.app === "hub";
	return input.granted;
}

/**
 * Platform ownership is not a workspace role.
 * A workspace owner is an operator only when one of these is true.
 */
export function isPlatformOperator(input: {
	emailOnAllowlist: boolean;
	recorded: boolean;
	developmentGrant: boolean;
}): boolean {
	return input.emailOnAllowlist || input.recorded || input.developmentGrant;
}
